var _circle, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTemplates(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#94BE43"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 33C15.45 33 14.9793 32.8043 14.588 32.413C14.196 32.021 14 31.55 14 31V17C14 16.45 14.196 15.979 14.588 15.587C14.9793 15.1957 15.45 15 16 15H32C32.55 15 33.021 15.1957 33.413 15.587C33.8043 15.979 34 16.45 34 17V31C34 31.55 33.8043 32.021 33.413 32.413C33.021 32.8043 32.55 33 32 33H16ZM16 31H32V17H16V31ZM17 29H22V27H17V29ZM26.55 27L31.5 22.05L30.075 20.625L26.55 24.175L25.125 22.75L23.725 24.175L26.55 27ZM17 25H22V23H17V25ZM17 21H22V19H17V21Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemplates);
export default __webpack_public_path__ + "static/media/templates.dbf52fdfe1e3b15efdf511d1e3fc6771.svg";
export { ForwardRef as ReactComponent };